import { NavLink } from "react-router-dom";
import { cn } from "@/lib/cn";
import { NAV_ITEMS } from "./navItems";

export function Sidebar() {
  return (
    <aside className="hidden lg:flex w-56 shrink-0 flex-col border-r border-border bg-bg-elevated">
      <nav className="flex flex-col gap-0.5 p-2">
        {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-2 px-2 py-1.5 text-sm rounded relative",
                "text-text-muted hover:text-text hover:bg-bg-subtle",
                isActive && "text-text bg-bg-subtle",
                isActive && "before:absolute before:left-0 before:top-1 before:bottom-1 before:w-0.5 before:bg-accent",
              )
            }
          >
            <Icon className="size-4" />
            {label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
